/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum responseTypeEnum {
    ALL = 'all',
    ATTACHMENT = 'attachment',
    CSRINFO = 'csrinfo',
    QSTLOG = 'qstlog',
    RESPONSE = 'response',
    RESP_ATTACH = 'resp_attach',
}